import RichText from '../../components/RichText/RichText'

export default function PrivacyTerms (props = {
    data: null
}) {
    const data = props.data[0] || {}

    const modifiedDate = data.modified
        && new Date(data.modified)

    const modified = modifiedDate
        && `${modifiedDate.toLocaleString('default', { month: 'long' })} ${
            modifiedDate.getDate()}, ${modifiedDate.getFullYear()}`

    const modifiedTimestamp = modifiedDate
        && `${modifiedDate.getFullYear()}-${
            (modifiedDate.getMonth() + 1).toString().padStart(2, '0')}-${
            modifiedDate.getDate().toString().padStart(2, '0')}`

    const getSlug = (str) => (str || '')
        .toLowerCase()
        .replace(/[^a-z0-9]/g, '-')
        .replace(/-{2,}/, '-')

    let sections = data?.sections || [{
        topics: data?.topics || []
    }]

    sections = sections
        .map(obj => Object.assign(obj, {
            id: getSlug(obj?.title),
            topics: (obj.topics || [])
                .map(_obj => _obj?.title && _obj?.richText
                    ? Object.assign(_obj, {
                        id: getSlug(_obj.title)
                    })
                    : null)
                .filter(_obj => _obj)
        }))
        .filter(obj => (obj.topics || [])
            .length)

    let topics = (data.topics || [])
        .filter(obj => obj.title && obj.richText)

    const topicIds = topics
        .map(obj => getSlug(obj.title))

    topics = topics
        .map((obj, idx) => Object.assign(obj, {
            id: `${topicIds[idx]}${
                idx !== topicIds.indexOf(topicIds[idx])
                    ? `-${idx}`
                    : ''}`
        }))

    const renderSection = (obj, idx) => (
        <section
            key={`privacy-terms-section-${idx}`}
            id={obj.title
                && getSlug(obj.title)}
            className="privacy-terms-section"
        >
            {obj.title
                && obj.id
                && (
                    <h2>
                        <a
                            href={`#${obj.id}`}
                        >
                            {obj.title}
                        </a>
                    </h2>)}
            <RichText
                html={obj.richText}
            />
            {(obj.topics || [])
                .map((_obj, _idx) => (
                    <div
                        id={_obj.id}
                        key={`topics-item-${_idx}`}
                        className="privacy-terms-section-item"
                        tabIndex="-1"
                    >
                        <h2
                            className="heading-5 margin-1-b"
                        >
                            <a
                                href={`#${_obj.id}`}
                            >
                                {_obj.title}
                            </a>
                        </h2>
                        <RichText
                            html={_obj.richText}
                        />
                    </div>
                ))}
        </section>
    )

    return (
        <article className="privacy-terms pad-section">
            <div className="container">
                <div className="row flex-justify-content-center">
                    <div className="privacy-terms-content col-12 col-10-lg col-8-xl-up">
                        <h1 className="margin-4-b margin-5-b-lg-up">
                            <span
                                className="display-block"
                            >
                                {data.heading || 'Privacy & Terms'}
                            </span>
                            {modified
                                && (
                                    <span
                                        className="display-block body-4 margin-1-t"
                                    >
                                        Modified:&nbsp;
                                        <time
                                            dateTime={modifiedTimestamp}
                                        >
                                            {modified}
                                        </time>
                                    </span>
                                )}
                        </h1>
                        <RichText
                            html={data.richText}
                        />
                        <a
                            href={`#${sections[0]?.id}`}
                            className="skip-to"
                        >
                            Skip table of contents
                        </a>
                        <nav aria-label="Table of contents">
                            <h2
                                className="heading-5 margin-1-b"
                                aria-hidden="true"
                            >
                                <span>Topics</span>
                            </h2>
                            <ul>
                                {sections
                                    .filter(obj => (obj.id && obj.title)
                                        || Boolean((obj.topics || []).length))
                                    .map((obj, idx) => {
                                        const renderTopics = () => obj.topics
                                            .filter(obj => obj.id && obj.title)
                                            .map((_obj, _idx) => (
                                                <li
                                                    key={`privacy-terms-nav-item-${idx}-${_idx}`}
                                                >
                                                    <a
                                                        href={`#${_obj.id}`}
                                                    >
                                                        {_obj.title}
                                                    </a>
                                                </li>
                                            ))

                                        return !obj.id || !obj.title
                                            ? renderTopics()
                                            : (
                                                <li
                                                    key={`privacy-terms-nav-item-${idx}`}
                                                >
                                                    <a
                                                        href={`#${obj.id}`}
                                                    >
                                                        {obj.title}
                                                    </a>
                                                    <ul>
                                                        {renderTopics()}
                                                    </ul>
                                                </li>)
                                    })}
                            </ul>
                        </nav>
                        {sections
                            .map(renderSection)}
                    </div>
                </div>
            </div>
        </article>
    )
}
